export default __webpack_public_path__ + "static/media/glp_icon.ef02d046.svg";